import React from 'react';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody,
  Button, FormControl, FormLabel, Input, Select, Flex, Text, Alert, AlertIcon, Textarea,
} from '@chakra-ui/react';
import * as FiIcons from 'react-icons/fi';
import { createShopItem } from '../../../../../store/shopItems/shopItemsSlice';
import theme from '../../../../global/theme';

const CATEGORIES = ['سلاح', 'درع', 'خوذه', 'حذاء', 'حلق', 'قلادة'];

const CreateModal = ({ onClose }) => {
  const dispatch = useDispatch();
  const shopItems = useSelector(state => state.shopItems);
  const { register, handleSubmit, formState: { errors } } = useForm({
    defaultValues: { type: 'بيع', category: 'سلاح', price_num: 0 }
  });

  const onSubmit = (values) => {
    const fd = new FormData();
    Object.entries(values).forEach(([key, val]) => {
      if (key !== 'images') fd.append(key, val);
    });
    if (values.images?.length) {
      Array.from(values.images).forEach(file => fd.append('images', file));
    }
    dispatch(createShopItem(fd)).unwrap().then(() => onClose());
  };

  return (
    <Modal isOpen onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent borderRadius={4} paddingBlock={4} bg={theme.dark}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader textAlign="center" color="orange" fontSize={20}>إضافة إعلان</ModalHeader>
          <ModalBody>
            {shopItems.errors.length > 0 && (
              <Alert status="error" variant="left-accent" marginBottom={4}>
                <AlertIcon />
                {shopItems.errors.map((e, i) => <Text key={i}>{e?.msg}</Text>)}
              </Alert>
            )}
            <FormControl mb={4}>
              <FormLabel color={theme.light}>اسم العنصر *</FormLabel>
              <Input bg={theme.light} border="none" borderRadius={4}
                {...register('name', { required: 'مطلوب' })} />
              {errors.name && <Text color="red.400" mt={1}>{errors.name.message}</Text>}
            </FormControl>
            <Flex gap={4} mb={4}>
              <FormControl>
                <FormLabel color={theme.light}>التصنيف</FormLabel>
                <Select bg={theme.light} border="none" borderRadius={4} {...register('category')}>
                  {CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
                </Select>
              </FormControl>
              <FormControl>
                <FormLabel color={theme.light}>النوع</FormLabel>
                <Select bg={theme.light} border="none" borderRadius={4} {...register('type')}>
                  <option value="بيع">بيع</option>
                  <option value="شراء">شراء</option>
                </Select>
              </FormControl>
            </Flex>
            <Flex gap={4} mb={4}>
              <FormControl>
                <FormLabel color={theme.light}>السعر (نص)</FormLabel>
                <Input bg={theme.light} border="none" borderRadius={4} placeholder="5,000 ذهب" {...register('price')} />
              </FormControl>
              <FormControl>
                <FormLabel color={theme.light}>السعر (رقم)</FormLabel>
                <Input type="number" bg={theme.light} border="none" borderRadius={4} {...register('price_num')} />
              </FormControl>
            </Flex>
            <Flex gap={4} mb={4}>
              <FormControl>
                <FormLabel color={theme.light}>السيرفر</FormLabel>
                <Input bg={theme.light} border="none" borderRadius={4} placeholder="الكل" {...register('server')} />
              </FormControl>
              <FormControl>
                <FormLabel color={theme.light}>البائع</FormLabel>
                <Input bg={theme.light} border="none" borderRadius={4} {...register('seller')} />
              </FormControl>
            </Flex>
            <Flex gap={4} mb={4}>
              <FormControl>
                <FormLabel color={theme.light}>الصور</FormLabel>
                <Input bg={theme.light} border="none" borderRadius={4} type="file" accept="image/*" multiple
                  paddingTop={1} {...register('images')} />
              </FormControl>
              <FormControl>
                <FormLabel color={theme.light}>ديسكورد للتواصل</FormLabel>
                <Input bg={theme.light} border="none" borderRadius={4} {...register('contact_discord')} />
              </FormControl>
            </Flex>
            <FormControl mb={4}>
              <FormLabel color={theme.light}>الوصف</FormLabel>
              <Textarea bg={theme.light} border="none" borderRadius={4} rows={3} {...register('description')} />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Flex justifyContent="flex-end" gap={3}>
              <Button type="submit" rightIcon={<FiIcons.FiSave />} colorScheme="green"
                isLoading={shopItems.isLoading}>حفظ</Button>
              <Button type="button" rightIcon={<FiIcons.FiX />} colorScheme="red"
                isLoading={shopItems.isLoading} onClick={onClose}>إلغاء</Button>
            </Flex>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default CreateModal;
